<template>
    <transition>
        <div @click="close" class="popup__backdrop" v-if="isOpen">
            <div class="popup" @click.stop>
                <button @click.stop.prevent="close" class="popup__close">
                    <icon-component name="close" width="32" height="32" class="popup__close-icon"/>
                </button>
                <div class="popup__header">
                    <h3 class="popup__title">
                        <slot name="title" ></slot>
                    </h3>
                    <slot name="additional_title_info"></slot>
                </div>
                <div :class="{popup__content: mt}">
                    <slot name="content" :close="close" :confirm="confirm">
                    </slot>
                </div>
            </div>
        </div>
    </transition>
</template>
<script setup lang="ts">
import iconComponent from '../shared/iconComponent.vue';
const props = defineProps({
    isOpen: {
        type: Boolean,
        required: true
    },
    mt: {
        type: Boolean
    }
})
const emit = defineEmits({
    close: null,
    confirm: null
})
const close = () => {
    emit("close")
}
const confirm = () => {
    emit("confirm")
}


</script>